/* eslint-disable no-useless-catch */
import { identityService } from 'api/services';
import { Credentials } from 'slice';

const pathname = '/users';

export const AuthApi = {
  login: async (credentials: Credentials) => {
    try {
      const response = await identityService.post(
        `${pathname}/login-with-password`,
        credentials
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  loginWithEmail: async (credentials: Credentials) => {
    try {
      return await identityService.post(
        `${pathname}/login-with-email`,
        credentials
      );
    } catch (error) {
      throw error;
    }
  },

  refreshAccessToken: async (refreshToken: string) => {
    try {
      const response = await identityService.post(`${pathname}/refresh-token`, {
        refreshToken,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  logout: async () => {
    try {
      const response = await identityService.post(`${pathname}/logout`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  resetPassword: async (data: ResetPasswordBody) => {
    try {
      return await identityService.post(`${pathname}/reset-password`, data);
    } catch (error) {
      throw error;
    }
  },
};

export interface ResetPasswordBody {
  token: string;
  newPassword: string;
}
